import { ADJUSTMENT_TYPE_LABEL } from "../../common/adjustments";

export const BUS_STATION_TRANSACTION_TYPE_LABELS = {
  park: "Dwell Fee",
  gateway_transaction: "Reconciliation Charge",
  adjustment: ADJUSTMENT_TYPE_LABEL,
} as const;
